<template>
</template>

<script>

export default {
  name: 'ShareUrl',
  data() {
    return{

    };
  },
  created() {},
  mounted() {
    this.loading()
    // let queryObj = this.getUrlCode()
    let url = decodeURIComponent(this.$route.query.url)
    let id = this.$route.query.id
    console.log(`id=${id},url=${url}`)
    window.location.href = `${url}?id=${id}`
    this.$toast.clear()
  },
  methods: {
    loading(){
      this.$toast.loading({
        message: '加载中...',
        loadingType: 'spinner',
        duration: 0
      })
    },
    getUrlCode() { // 截取url中的key方法
      let url = window.location.search
      let theRequest = new Object()
      if (url.indexOf("?") != -1) {
        let str = url.substr(1)
        let strs = str.split("&")
        for(let i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
        }
      }
      return theRequest
    }
  },
}
</script>
<style>
.van-loading{
  text-align: center;
}
</style>
